import { ReactNode } from 'react';

import { NoteView } from '@ndvr/customer-api';

import {
    cleanNoteList,
    MEETING_MINUTES_SECTION_LABEL_CLASSES,
    splitIntoParagraphs,
} from '../meeting-minutes-list-utils';

const SectionLabel = ({ children }: { children: ReactNode }) => (
    <h4 className={MEETING_MINUTES_SECTION_LABEL_CLASSES}>{children}</h4>
);

// A note's AI Summary, Decisions and Next steps, as read on the Meeting Minutes card and the note
// page's Summary tab. Always renders its column, so a grid parent keeps its layout when it's empty.
export const MeetingMinutesNoteSections = ({ note }: { note: NoteView }) => {
    const summaryParagraphs = splitIntoParagraphs(note.summary);
    const decisions = cleanNoteList(note.decisions);
    const nextSteps = cleanNoteList(note.nextSteps);

    return (
        <div className="flex min-w-0 flex-col gap-4">
            {summaryParagraphs.length > 0 && (
                <section>
                    <SectionLabel>Summary</SectionLabel>
                    <div className="text-cocoa-1000 space-y-2 text-sm">
                        {summaryParagraphs.map((paragraph, index) => (
                            <p key={index}>{paragraph}</p>
                        ))}
                    </div>
                </section>
            )}
            {(decisions.length > 0 || nextSteps.length > 0) && (
                <div className="grid grid-cols-1 gap-x-8 gap-y-4 md:grid-cols-2">
                    {decisions.length > 0 && (
                        <section>
                            <SectionLabel>Decisions</SectionLabel>
                            <ul className="text-cocoa-1000 space-y-1 text-sm">
                                {decisions.map((decision, index) => (
                                    <li key={index} className="flex gap-2">
                                        <span aria-hidden>-</span>
                                        <span>{decision}</span>
                                    </li>
                                ))}
                            </ul>
                        </section>
                    )}
                    {nextSteps.length > 0 && (
                        <section>
                            <SectionLabel>Next steps</SectionLabel>
                            <div className="text-cocoa-1000 space-y-2 text-sm">
                                {nextSteps.map((step, index) => (
                                    <p key={index}>{step}</p>
                                ))}
                            </div>
                        </section>
                    )}
                </div>
            )}
        </div>
    );
};
